import { ReactNode } from 'react';
import UserAchievement from './UserAchievement';
import { Stack } from '@mui/system';
import UserIntroduce from './UserIntroduce';
import UserActions from './UserActions';
import { ColorButton } from '@/views/elements/button/ButtonElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';

type UserInfoViewProps = {
    achivements: Array<{title: string, value?: any, render?: ReactNode}>
    section: string,
    title: string,
    name: string;
    avatarUrl?: string;
    registerDate: string;
    rank: string;
    investthesis?: string;
    shortinvestthesis?: string;
    linkaccount?: string;
    custodycd?: string;
    actions: Array<{
        appendIcon?: ReactNode; 
        prependIcon?: ReactNode;
        label: string;
        onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
        disabled?: boolean;
        color?: ColorButton;
    }>
}

const UserInfoView = ({achivements, section, actions, title, name, avatarUrl, rank, registerDate, investthesis, shortinvestthesis, linkaccount, custodycd}: UserInfoViewProps) => {
    return (
      <Stack p={0} spacing='20px'>
        <Stack>
          <TypographyElement FontSizeElement='12px' ColorElement='secondary' sx={{ lineHeight: '18px' }}>{section}</TypographyElement>
          <TypographyElement FontSizeElement='18px' FontWeightElement={700}>
            {title}
          </TypographyElement>
        </Stack>
        <Stack direction="row">
          <UserIntroduce
            name={name}
            avatarUrl={avatarUrl}
            rank={rank}
            registerDate={registerDate}
            investthesis={investthesis}
            shortinvestthesis={shortinvestthesis}
            linkaccount={linkaccount}
            custodycd={custodycd}
          />
          <UserAchievement achivements={achivements} />
        </Stack>
        <UserActions actions={actions} />
      </Stack>
    );
};

export default UserInfoView;